/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.
*/

(function() {
  // Grid Slider for Collection List
  class GridSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-grid-slider]');
      if (!this.slider) return;

      this.slider.style.overflowX = 'auto';
      this.slider.style.display = 'flex';
      this.slider.style.flexWrap = 'nowrap';
      this.slider.style.scrollSnapType = 'x mandatory';
      this.slider.style.webkitOverflowScrolling = 'touch';
      this.slider.style.scrollbarWidth = 'none';

      this.slider.querySelectorAll('.grid__item').forEach(item => {
        item.style.flex = '0 0 auto';
        item.style.scrollSnapAlign = 'start';
      });
    }
  }

  if (!customElements.get('grid-slider')) {
    customElements.define('grid-slider', GridSlider);
  }
})();

// Mobile menu accordion
function initMobileAccordion() {
  document.querySelectorAll('mobile-sliderule').forEach(function (sliderule) {
    if (sliderule._accordionInit) return;
    sliderule._accordionInit = true;

    const btn = sliderule.querySelector('button.sliderow[data-sliderule-open]');
    const panel = sliderule.querySelector('.mobile__menu__dropdown');
    if (!btn || !panel) return;

    const hideBackRow = function() {
      const backRow = panel.querySelector('.sliderow--back');
      if (backRow) {
        backRow.style.cssText = 'display:none!important;height:0!important;max-height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;min-height:0!important;';
      }
    };

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();

      const isOpen = sliderule.classList.contains('accordion--open');

      // Fechar siblings
      const parent = sliderule.closest('[data-links], .sliderow__links');
      if (parent) {
        parent.querySelectorAll('mobile-sliderule.accordion--open').forEach(function (s) {
          if (s !== sliderule) {
            s.classList.remove('accordion--open');
            const p = s.querySelector('.mobile__menu__dropdown');
            if (p) p.style.maxHeight = '0';
          }
        });
      }

      if (isOpen) {
        sliderule.classList.remove('accordion--open');
        panel.style.maxHeight = '0';
      } else {
        sliderule.classList.add('accordion--open');

        hideBackRow();

        panel.querySelectorAll('[data-animates]').forEach(function (el) {
          el.style.opacity = '1';
          el.style.visibility = 'visible';
          el.style.transform = 'none';
          el.style.animationName = 'none';
        });

        setTimeout(function () {
          hideBackRow();
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }, 10);

        setTimeout(function () {
          hideBackRow();
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }, 300);
      }
    }, true);
  });
}

// Observar DOM para quando o Broadcast inicializar o menu
new MutationObserver(function () {
  initMobileAccordion();
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', initMobileAccordion);
document.addEventListener('shopify:section:load', initMobileAccordion);

// UpCart <> Broadcast Bridge
// O UpCart não dispara o evento 'theme:cart:change' do Broadcast,
// por isso o ícone da bag não actualiza. Este código faz a ponte.
(function() {
  function broadcastCartUpdate() {
    fetch('/cart.json')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cartCount: cart.item_count }
        }));
      })
      .catch(function() {});
  }

  // UpCart fires these custom events on the document
  document.addEventListener('upcart:open', broadcastCartUpdate);
  document.addEventListener('upcart:close', broadcastCartUpdate);
  document.addEventListener('upcart:add', broadcastCartUpdate);
  document.addEventListener('upcart:remove', broadcastCartUpdate);
  document.addEventListener('upcart:change', broadcastCartUpdate);
  document.addEventListener('upcart:update', broadcastCartUpdate);

  // Fallback: intercept Shopify cart API calls (add/change/clear)
  // so we catch all cart mutations regardless of what UpCart fires
  var _fetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = _fetch.apply(this, arguments);
    if (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/clear') !== -1 ||
      url.indexOf('/cart/update') !== -1
    ) {
      result.then(function(response) {
        response.clone().json().then(function() {
          setTimeout(broadcastCartUpdate, 150);
        }).catch(function() {
          setTimeout(broadcastCartUpdate, 150);
        });
        return response;
      }).catch(function() {});
    }
    return result;
  };
})();

// Contador da bag: estilo vermelho sem número
(function() {
  var style = document.createElement('style');
  style.textContent = [
    /* Esconde o número dentro do badge */
    'cart-count.header__cart__status { color: transparent !important; font-size: 0 !important; }',

    /* Badge vermelho */
    '.header__cart__status__holder cart-count.header__cart__status {',
    '  background: #e53030 !important;',
    '  border-color: #e53030 !important;',
    '  min-width: 10px !important;',
    '  min-height: 10px !important;',
    '  width: 10px !important;',
    '  height: 10px !important;',
    '  border-radius: 50% !important;',
    '  padding: 0 !important;',
    '}',

    /* Esconde quando carrinho está vazio (data-cart-count="0") */
    '.header__cart__status__holder cart-count.header__cart__status[data-cart-count="0"] {',
    '  display: none !important;',
    '}',
  ].join('\n');
  document.head.appendChild(style);
})();

// Checkout button uppercase (Broadcast nativo + UpCart)
(function() {
  var style = document.createElement('style');
  style.textContent = [
    'button[name="checkout"], .cart__checkout, .cart__checkout .btn__text,',
    '.upcart-checkout-button, .upcart-checkout-button-container a {',
    '  text-transform: uppercase !important;',
    '  letter-spacing: 0.5px;',
    '}'
  ].join('\n');
  document.head.appendChild(style);
})();

